import { styled } from 'styled-components';

import { Loader } from '@sharedComponents/Loader';

export const SLoader = styled(Loader)`
  min-width: 12.5rem;
`;
